import React, { useCallback, useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { ReportingContext } from '../../../../wrappers/ReportingContext'
import { reportingLayoutConfig } from '../../../../../utils/reporting/config'
import ConfirmationModal from '../../../../features/reporting/ConfirmationModal'
import UnsavedChangesModal from './UnsavedChangesModal'
import stringFields from '../../../../../utils/constants/widgets/stringFields'
import { FaTimesCircle } from 'react-icons/fa'

const Sidebar = () => {
    const { 
        selectedFormSection, 
        setSelectedFormSection, 
        setHasUnsavedChanges, 
        setClickedTab,
        report
    } = useContext(ReportingContext)
    const isNewReport = !report?.DatabaseName || report.DatabaseName.trim() === '' ||  selectedFormSection === 'Create Report';
    const { errors, formState: { dirty, isSubmitted }, watch } = useFormContext()
    
    //This is important to calculate is dirty, DO NOT DELETE
    const allData = watch({ nest: true })

    useEffect(() => {
        if (isNewReport && selectedFormSection !== 'Create Report') {
            setSelectedFormSection('Create Report');
        }
    }, [isNewReport, selectedFormSection, setSelectedFormSection]);

    const getSectionHasError = useCallback(
        (sectionName) => {
            if (sectionName === 'Create Report') {
                if (!isSubmitted) return false
                return (
                    errors?.reportName ||
                    errors?.reportDescription ||
                    errors?.databaseName
                )
            }
            if (sectionName === 'Report Information') {
                if (!isSubmitted || isNewReport) return false
                return (
                    errors?.reportName ||
                    errors?.reportDescription ||
                    errors?.databaseName ||
                    errors?.primaryDataSourceName
                )
            }
            if (sectionName === 'Joins') {
                return errors?.joins
            }
            if (sectionName === 'Select Columns') {
                return errors?.columns || errors?.limit || errors?.hasDistinct//|| errors?.calculatedColumns
            }
            if (sectionName === 'Where Clause') {
                return errors?.filters
            }
            if (sectionName === 'Group By Columns') {
                return errors?.groupBy
            }
            if (sectionName === 'Order By Columns') {
                return errors?.orderBy
            }
            return false
        },
        [errors, isSubmitted]
    )

    const changeActiveTab = useCallback(form => {
        if (dirty === true) {
            setClickedTab(form)
            setHasUnsavedChanges(true)
        } else {
            setSelectedFormSection(form)
        }
    }, [dirty, setSelectedFormSection, setHasUnsavedChanges, setClickedTab])

    const filteredLayoutConfig = isNewReport 
        ? reportingLayoutConfig
        : reportingLayoutConfig.filter(item => item.name !== 'Create Report')

    return (
        <aside className="menu">
            <ul className="menu-list">
                {filteredLayoutConfig.map((item, index) => {
                    const isDisabled = isNewReport && item.name !== 'Create Report'

                    return (
                        <li
                            className={`icon-text ${isDisabled ? 'is-disabled' : ''}`}
                            key={index}
                            onClick={() => {
                                if (!isDisabled) {
                                    changeActiveTab(item.name)
                                }
                            }}
                            style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                        >
                            <span>
                                <a
                                    className={`is-flex sidebarEdit ${
                                        selectedFormSection === item.name 
                                        ? 'is-active'
                                         : ''
                                    }`}
                                >
                                    <div className=''>
                                        {item.name}
                                    </div>
                                    <div className="icon">
                                        {getSectionHasError(item.name) ? (
                                            <FaTimesCircle className="has-text-danger" />
                                        ) : null}
                                    </div>
                                </a>
                            </span>
                        </li>
                    )
                })}
            </ul>
        </aside>

    )
}

export default Sidebar
